import styled from 'styled-components/native';

import LogoImage from 'components/LogoImage';

export default styled(LogoImage)``;
